import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 mt-auto" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_tank-fashion/artifacts/rut5gr1k_igor-final.png" 
                alt="3T Logo" 
                className="h-12 w-auto"
              />
              <span className="font-heading text-4xl tracking-tighter">3T</span>
            </Link>
            <p className="text-[#A3A3A3] text-sm mt-3">Ideas worth wearing.</p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.instagram.com/think3t"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#FFD700] hover:text-[#FFD700] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61585027051150"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-[#FFD700] hover:text-[#FFD700] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div className="md:col-span-1">
            <h4 className="font-heading text-lg tracking-wider mb-4">SHOP</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-shop">
                  Shop
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-lg tracking-wider mb-4">ABOUT</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/philosophy" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-philosophy">
                  Our Philosophy
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-lg tracking-wider mb-4">SUPPORT</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shipping" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-shipping">
                  Shipping
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-returns">
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-refund">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-faq">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-1">
            <h4 className="font-heading text-lg tracking-wider mb-4">LEGAL</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-terms-link">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-lg tracking-wider mb-4">ACCOUNT</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/auth" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-login">
                  Login
                </Link>
              </li>
              <li>
                <Link to="/orders" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-orders">
                  Orders
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="text-[#A3A3A3] hover:text-[#FFD700] transition-colors" data-testid="footer-wishlist">
                  Wishlist
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#A3A3A3] text-sm font-mono">
            &copy; 2025 3T. ALL RIGHTS RESERVED.
          </p>
          <p className="text-[#A3A3A3] text-sm font-mono">
            WEAR THE MESSAGE
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
